import { render } from "./iaStatus.vue?vue&type=template&id=5b72b08f"
import script from "./iaStatus.vue?vue&type=script&lang=js"
export * from "./iaStatus.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\FrankCastelijns\\bzx_status\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__